import React, { useMemo } from "react";
import AuthProvider from "../../auth/AuthProvider";
import JamezzFormV2 from "../JamezzForm/JamezzFormV2";
import TranslationWrapper, { getTranslation } from "../../components/TranslationWrapper/TranslationWrapper";
import Algemeen from "./Tabs/Algemeen";
import Branding from "./Tabs/Branding";
import Translations from "./Tabs/Translations";
import Extra from "./Tabs/Extra";
import Apidata from "./Tabs/Apidata";
import MenukaartTimeTable from "./Tabs/MenukaartTimeTable";
import { connect } from "react-redux";
import CurrencyProvider from "../../components/Forms/CurrencyProvider";
import useVestigingRelation from "../../components/Forms/useVestigingRelation";
import VestigingProvider from "../../components/Forms/VestigingProvider";
import { formatTitle } from "../../../utils/formatting";
import { Link } from "react-router";
import { useSwitchToSalesarea } from "../Vestigingen/UseSwitchToSalesarea";

function MenukaartForm(props) {
  const endPoint = useMemo(() => {
    return "core/kaarten";
  }, []);

  const { currency, menukaartVestigingId, vestiging, extraFields, onGetModel } = useVestigingRelation({
    vestiging_id: props.vestiging_id,
    routerMatch: props.match,
    history: props.history,
    endPoint,
  });

  useSwitchToSalesarea(vestiging);

  return (
    <AuthProvider prefix={"menukaarten"}>
      <CurrencyProvider currency={currency}>
        <VestigingProvider vestiging={vestiging}>
          <JamezzFormV2
            computedPageTitle={function (model) {
              return formatTitle(this.pageTitle, model.naam);
            }}
            endPoint={endPoint}
            excludedKeysInOutput={{ vestiging: true }}
            extraFields={extraFields}
            extraFormProps={{ vestiging, vestigingId: vestiging?.id, menukaartVestigingId }}
            mode={"onSubmit"}
            objectsExcludedAsRelation={{
              translations: true,
              rawApiData: true,
            }}
            onGetModel={onGetModel}
            pageTitle={getTranslation("menukaarten.form.pageTitle", "Menukaart")}
            pageTitleSubject={
              <small>
                <Link to={`/manager/vestigingen/${vestiging?.id}/edit`}>{vestiging?.naam}</Link> - {vestiging?.id}
              </small>
            }
            parseInput={{
              translations: (response) => (response ? JSON.parse(response) : null),
              rawApiData: (response) => (response ? JSON.parse(response) : null),
              settings: (response) => {
                return response ? JSON.parse(response) : {};
              },
            }}
            parseOutput={{
              translations: (translations) => (translations ? JSON.stringify(translations) : null),
              settings: (object) => JSON.stringify(object),
              opening_hours: (object) => JSON.stringify(object),
            }}
            revalidateMode={"onChange"}
            rootRight={"menukaarten"}
            tabs={[
              {
                right: "algemeen",
                tabButton: <TranslationWrapper tDefault={"Algemeen"} tKey={"menukaarten.form.tabs.algemeen"} />,
                tabContent: <Algemeen />,
              },
              {
                right: "afbeelding",
                tabButton: (
                  <TranslationWrapper tDefault={"Branding / Design"} tKey={"vestigingen.form.tabs.branding"} />
                ),
                tabContent: <Branding />,
              },
              {
                right: "vertalingen",
                tabButton: <TranslationWrapper tDefault={"Translations"} tKey={"translations"} />,
                tabContent: <Translations />,
              },
              {
                right: "timetable",
                tabButton: <TranslationWrapper tDefault={"Tijd schema"} tKey={"menukaarten.form.tabs.timetable"} />,
                tabContent: <MenukaartTimeTable />,
              },
              {
                right: "extra",
                tabButton: <TranslationWrapper tDefault={"Extra"} tKey={"menukaarten.form.tabs.extra"} />,
                tabContent: <Extra />,
              },
              {
                right: "rawapidata",
                tabButton: <TranslationWrapper tDefault={"Raw api data"} tKey={"menukaarten.form.tabs.rawapidata"} />,
                tabContent: <Apidata />,
              },
            ]}
          />
        </VestigingProvider>
      </CurrencyProvider>
    </AuthProvider>
  );
}

const mapStateToProps = (state) => {
  return {
    vestiging_id: state.filtersV2.vestiging_id?.value,
  };
};

export default connect(mapStateToProps)(MenukaartForm);
